<!--
  管理端统一分页条。

  后台所有列表页共用这一个组件，避免「每个 panel 各写一遍 el-pagination」导致
  布局 / page-sizes / 事件名慢慢漂移（成就页当初就是这么漏掉了 background 和 sizes）。

  用法：
    <AdmPager
      :total="total" :page="query.page" :size="query.size"
      @page-change="onPageChange" @size-change="onSizeChange"
    />

  ⚠️ total 由后端 Long 经 JacksonConfig 序列化成**字符串**，这里统一 Number() 兜住。
  ⚠️ page-sizes 必须与后端各服务的 MAX_PAGE_SIZE（=100）对齐，否则选了 100 会被后端悄悄截断。
-->
<template>
  <div class="adm-pager">
    <el-pagination
      background
      layout="total, prev, pager, next, sizes"
      :total="totalNum"
      :current-page="pageNum"
      :page-size="sizeNum"
      :page-sizes="pageSizes"
      @current-change="$emit('page-change', $event)"
      @size-change="$emit('size-change', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'AdmPager',
  props: {
    /** 总条数（后端序列化成字符串，这里兼容两种类型） */
    total: { type: [Number, String], default: 0 },
    /** 当前页码 */
    page: { type: [Number, String], default: 1 },
    /** 每页条数 */
    size: { type: [Number, String], default: 20 },
    /** 可选每页条数，默认与后端 MAX_PAGE_SIZE 对齐 */
    pageSizes: { type: Array, default: () => [20, 50, 100] }
  },
  computed: {
    totalNum() {
      return Number(this.total) || 0
    },
    pageNum() {
      return Number(this.page) || 1
    },
    sizeNum() {
      return Number(this.size) || 20
    }
  }
}
</script>
